import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './brand.css';
import './index.css';
import App from './App.jsx';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Register the service worker once the page has loaded, so it never competes
// with first paint. Production builds only: the dev server would otherwise keep
// a worker alive across edits. A failure here must never break the app - the
// worker is for install and (later) push, not for anything the page needs.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('service worker did not register', err);
    });
  });
}
